import React, { useEffect } from "react";

import CloseIcon from "./assets/close.svg";
import { PopupConfig } from "./config";
import "./styles.less";
import { translate } from "react-polyglot";


const PreviewPopup = ({ closePopup, type, t }) => {
  useEffect(() => {
    const handleKeyPress = e => {
      if (e.code !== "Escape") return;
      closePopup();
    };

    window.addEventListener("keydown", handleKeyPress);
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      document.body.style.overflow = "unset";
    };
  });


  return (
    <div onClick={closePopup} className="preview-popup">
      <div onClick={e => e.stopPropagation()} className={`preview-popup__inner preview-popup__${type}`}>
        <div className="preview-popup__header">
          <button className="preview-popup__header-close-button" onClick={closePopup}>
            <img alt="close popup icon" className="preview-popup__header-close-icon" src={CloseIcon} />
          </button>

          <p className="preview-popup__header-title">{t(PopupConfig[type].title)}</p>
        </div>
        <div className="preview-popup__content">
          <img
            className="preview-popup__content-img preview-popup__content-img--desktop"
            src={PopupConfig[type].desktopImage}
            alt={PopupConfig[type].alt}
          />
          <img
            className="preview-popup__content-img preview-popup__content-img--mobile"
            src={PopupConfig[type].mobileImage}
            alt={PopupConfig[type].alt}
          />
        </div>
      </div>
    </div>
  );
};

export default translate()(PreviewPopup);



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/ui/preview-popup/index.js